import { render, staticRenderFns } from "./SendData.vue?vue&type=template&id=402dc3c1&"
import script from "./SendData.vue?vue&type=script&lang=js&"
export * from "./SendData.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/physicalShop/digipay/digipayStyle.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports